<template>
    <div class="container ">
        <div class="row mt-4 mt-md-5">
            <div class="col-12">
                <h1 class="font-poppins font-weight-extra-light color-blue">
                    {{ title}}
                </h1>
                <h6 class="font-poppins font-weight-light font-size-18 color-blue" v-if="subtitle">
                    {{ subtitle}}
                </h6>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        title: {
            type: String,
            default: null
        },
        subtitle: {
            type: String,
            default: null
        }
    },
}
</script>
